'use client';

import { c as _c } from "react/compiler-runtime";
import { type UpFetch, useUpFetch } from '@repo/upfetch';
import { useMemo } from 'react';
import { createRouter } from './routes';
export { getApiErrorCode } from './lib/get-api-error-code';
export { getApiErrorMessage } from './lib/get-api-error-message';
export type { ApiErrorMessageEntry } from './lib/get-api-error-message';
export { LoadsListSchema } from './routes/loads/list';
export type { LoadsListPage } from './routes/loads/list';
export { CreateDuplicateInputSchema, LoadStatusReasonsSchema } from './routes/loads/route';
export type { ChatMessagesPage, CreateDuplicateInput } from './routes/loads/route';
export { PaymentTermsOptionsSchema } from './routes/payment-terms/route.ts';
export type { PaymentTermsOptions } from './routes/payment-terms/route.ts';
export type { CreateSavedViewInput, SavedViewsAccess, SavedViewsInput, UpdateSavedViewAudienceInput, UpdateSavedViewInput } from './routes/table-configurations/route.ts';
export type { PageDataPath } from './routes/users/route';

// One router per upFetch, shared by every caller under it: building one constructs every route's
// schemas, which made each table cell that calls `useApi` slow to mount.
const routers = new WeakMap<UpFetch, ReturnType<typeof createRouter>>();
const getRouter = (upFetch: UpFetch) => {
  let router = routers.get(upFetch);
  if (!router) {
    router = createRouter(upFetch);
    routers.set(upFetch, router);
  }
  return router;
};
export const useApi = () => {
  const $ = _c(2);
  const upFetch = useUpFetch();
  let t0;
  if ($[0] !== upFetch) {
    t0 = getRouter(upFetch);
    $[0] = upFetch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};